import { Button } from 'src/components';
import styled, { css } from 'styled-components';

export const Wrapper = styled.div`
  .modal-body {
    overflow-x: hidden;
    position: relative;
    & + div {
      justify-content: space-between;
      padding-right: 35px;
    }
  }

  .okModalBtn {
    border: 0;
    border-radius: 6px;
    text-transform: uppercase;
    height: 38px;
    padding: 0 33px;
    cursor: pointer;
    border-width: 0;
    ${({ okBtnClickable }) => (!okBtnClickable ? css`
      background-color: ${props => props.theme.colors.disableEvolutiveButton}; 
      color: ${props => props.theme.colors.disableEvolutiveTextBtn}; 
      pointer-events: none;
    ` : css`
      background-color: ${(props) => props.theme.colors.backgroundItemColor};
      color: ${(props) => props.theme.colors.normalButtonHoverTextColor};
    `)}
  }

  .cancelModalBtn {
    background-color: ${(props) => props.theme.colors.clearButtonBackgroundColor};
    border: 0;
    border-radius: 6px;
    text-transform: uppercase;
    color: ${(props) => props.theme.colors.headerGroupInputsColorWhenSelected};
    height: 38px;
    padding: 0 33px;
    cursor: pointer;
    border-width: 0;

    &:hover{
      background-color: ${(props) => props.theme.colors.clearButtonHoverBackgroundColor};
      color: ${(props) => props.theme.colors.clearButtonHoverTextColor};
    }
  }

  .icon-wrapper .icon {
    fill: none !important;
    stroke: #FFF;
  }
`;

export const AbsoluteContainer = styled.div`
  position: absolute;
  width: 100%;
  left: 0;
  top: 20px;

  border: 1px solid ${({ theme }) => theme.colors.component};
`;

export const Container = styled.div`
  display: flex;

  .inputText{
    background-color: ${(props) => props.theme.colors.modalInputSearchBackgroundColor};
    border-radius: 5px;
  }

  padding: 20px 20px;

  flex-direction: column;
  width: 100%;
`;

export const Label = styled.div`
  color: ${(props) => props.theme.colors.UploadSurveyTitleColor};
  padding: 5px;
  font-size: 1.4em;
  margin-bottom: 26px;

  ${({ withIcon }) => (withIcon ? css`
    display: flex;

    & .icon {
      margin-right: 8.3px;
    }
  ` : '')}
`;

export const LabelSmall = styled.span`
  font-size: 12px;
  color: ${(props) => props.theme.colors.UploadSurveyTitleColor};
  font-weight: 300;

  ${({ withIcon }) => (withIcon ? css`
    display: flex;

    align-items: center;

    & .icon {
      margin-right: 8.3px;
    }
  ` : '')}
`;

export const FixedItem = styled.div`
  margin-bottom: 26px;
`;

export const TitleGroup = styled.div`
  width: 100%;
  margin-bottom: 10px;
`;

export const InputsWrapper = styled.div`
  width: 100%;
  display: flex;
  align-items: center;

  & > div {
    width: calc(75% - 10px);
    margin-right: 10px;

    .inputText {
      border-radius: 5px;
      color: ${(props) => props.theme.colors.headerGroupInputsColorWhenSelected};
    }
  }

  @media only screen and (max-width: 600px) {
    flex-direction: column;
    align-items: flex-start;

    & > div {
      width: 100%;
      margin-right: 0;
      margin-bottom: 10px;
    }

    button {
      width: 100%;
    }
  }
`;

export const ConsolidateBtn = styled(Button)`
  border-radius: 5px;
  height: 34px;
  background-color: ${({ theme }) => theme.colors.normalConsolidateButtonBackgroundColor};
  width: 25%;
`;

export const ToolTip = styled.div`
  width: 100%;
  height: 54px;
  display: flex;
  justify-content: center;
  align-items: center;
  border-bottom: 1px solid ${({ theme }) => theme.colors.component};
  text-align: center;
`;
